import { render, staticRenderFns } from "./facilitator.vue?vue&type=template&id=52604a2d&scoped=true&"
import script from "./facilitator.vue?vue&type=script&lang=js&"
export * from "./facilitator.vue?vue&type=script&lang=js&"
import style0 from "./facilitator.vue?vue&type=style&index=0&id=52604a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52604a2d",
  null
  
)

export default component.exports